// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sample-graph {
    border-collapse: collapse;
    margin: 10px 0;
}
.sample-graph td {
    border: 1px solid #888;
    padding: 0;
}
.sample-graph.horizontal td {
    height: 8px;
    width: 18px;
}
.sample-graph.vertical td {
    height: 16px;
    width: 8px;
}
.sample-graph.horizontal.slim td {
    height: 4px;
}
.sample-graph.vertical.slim td {
    width: 4px;
}

.sample-graph td.set {
    background-color: black;
}

.sample-graph tr.baseline td.set {
    background-color: #aaa;
}
.sample-graph td.baseline.set {
    background-color: #aaa;
}
`, "",{"version":3,"sources":["webpack://./src/ui/widgets/sample_graph.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,cAAc;AAClB;AACA;IACI,sBAAsB;IACtB,UAAU;AACd;AACA;IACI,WAAW;IACX,WAAW;AACf;AACA;IACI,YAAY;IACZ,UAAU;AACd;AACA;IACI,WAAW;AACf;AACA;IACI,UAAU;AACd;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;AAC1B;AACA;IACI,sBAAsB;AAC1B","sourcesContent":[".sample-graph {\n    border-collapse: collapse;\n    margin: 10px 0;\n}\n.sample-graph td {\n    border: 1px solid #888;\n    padding: 0;\n}\n.sample-graph.horizontal td {\n    height: 8px;\n    width: 18px;\n}\n.sample-graph.vertical td {\n    height: 16px;\n    width: 8px;\n}\n.sample-graph.horizontal.slim td {\n    height: 4px;\n}\n.sample-graph.vertical.slim td {\n    width: 4px;\n}\n\n.sample-graph td.set {\n    background-color: black;\n}\n\n.sample-graph tr.baseline td.set {\n    background-color: #aaa;\n}\n.sample-graph td.baseline.set {\n    background-color: #aaa;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
